/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';

import { css, StyleSheet } from 'aphrodite';
import { mixins } from '@blend/consumer-components';
import { DisableIEMode } from '../common/DisableIEMode/DisableIEMode';
import { DisableMobileMode } from '../common/DisableMobileMode/DisableMobileMode';
import { MobileWatcher } from '../common/MobileWatcher/MobileWatcher';
import { SkipToMainContent } from '../common/SkipToMainContent/SkipToMainContent';
import { NotificationList } from '../common/Notifications/NotificationList';
import { AccessibilityListeners } from './AccessibilityListeners';
import { Bootstrap } from './Bootstrap';
import { AppHeader } from './AppHeader/AppHeader';
import { ConsumerAppConfigProvider } from './ConsumerAppConfigProvider';
import { ScreenReaderMessage } from '@components/ScreenReaderMessage/ScreenReaderMessage';

export namespace App {
  export interface Props {}
}

const styles = StyleSheet.create({
  pageWrapper: {
    ...mixins.fillContainer(),
  },
  main: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
});

export const App: React.FC<App.Props> = ({ children }) => {
  return (
    <ConsumerAppConfigProvider>
      <AppHeader />
      <Bootstrap />
      <AccessibilityListeners />
      <DisableIEMode />
      <DisableMobileMode />
      <MobileWatcher />
      <div className={css(styles.pageWrapper)}>
        <SkipToMainContent />
        <ScreenReaderMessage id="js-main-content" hideOnMobile>
          Main Content
        </ScreenReaderMessage>
        <main className={css(styles.main)} role="main">
          <NotificationList />
          {children}
        </main>
      </div>
    </ConsumerAppConfigProvider>
  );
};
